<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DKVsKU/tc-custom/9781402781520.jpg?1736478797857" alt="This image is the cover for the book Lost to Time"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lost to Time
      </h1>
      <p class="bookDescription body article font2">
        <b>“A splendid book, full of fascinating, well-told tales . . . a diverse and bafflingly overlooked collection of historical curiosities” (<i>Booklist</i>, starred review).</b><br/><br/>“The only thing new in the world,” said Harry S. Truman, “is the history you don’t know.” In this fresh and fascinating collection of historical vignettes, National Book Award–winning author Martin W. Sandler restores to memory important events, people, and developments that have been lost to time. <br/><br/>Though barely known today, these are major historical stories, from Ziryab, an eighth-century black slave whose influence on music, cuisine, fashion, and manners still reverberates, to Cahokia, a twelfth-century city north of the Rio Grande, which at its zenith contained a population estimated to have been as high as 40,000 (more than any contemporary European city), to the worst peacetime maritime disaster ever, the explosion and sinking of the <i>Sultana</i> on the Mississippi in 1865.<br/><br/>These tales are far from trivia; they illuminate little-known American and foreign achievements, ingenuity, heroics, blunders, and tragedies that changed the course of history and resonate today.<br/><br/><b>“A very compelling collection of accounts about things not even mentioned in textbooks . . . People who love to read history will enjoy [<i>Lost to Time</i>].” —<i>Digital Journal</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martin W. Sandler
      </h2>
      
      <p class="authorDescription body article">Martin W. Sandler has received many honors, including two Pulitzer Prize nominations; a Boston Horn Book Award for The Story of American Photography: An Illustrated History for Young People (Little, Brown); and seven Emmys. His Library of Congress American History series has been a national bestseller with more than 500,000 copies sold. For television, Mr. Sandler was creator and cowriter for the acclaimed 12-part This Was America series. He has taught American history and American studies at UMass and Smith College. He lives in Cape Cod, MA.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sterling Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?32ff51e6